import React, { memo, useState } from "react";
import { Card, Col, Row } from "react-bootstrap";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { useTranslation } from "react-i18next";
import debounce from "lodash.debounce";
import AsyncSelect from "react-select/async";

import { Creators as ReportAreaActions } from "../../store/ducks/reportArea";
import SavedAreaService from "../../services/SavedArea";

const FilterSavedArea = ({
  props: { currentUser },
  funcs: { setReportArea }
}) => {
  const { t } = useTranslation();
  const savedAreaService = new SavedAreaService();
  const [areaSelectedOption, setAreaSelectedOption] = useState(null);

  const areaLoadOptions = (e, c) => areaLoadOptionsDebounce(e, c);
  const areaLoadOptionsDebounce = debounce(async (e, c) => {
    const docs = await savedAreaService.findAutocomplete({ data: { search: e }, token: currentUser.token });
    c((docs || []).map(a => ({ dataAux: a, label: a.name, value: a.id })));
  }, 500);

  const handleAreaChange = (selected) => {
    setAreaSelectedOption(selected);
    if (!selected) { setReportArea(null, null); return; }
    const saved = selected.dataAux;
    const area = saved.type === "circle"
      ? { type: "circle", center: { latitude: saved.center.lat, longitude: saved.center.lng }, radius: saved.radiusMeters || 50 }
      : { type: "polygon", coordinates: (saved.points || []).map(p => ({ latitude: p.lat, longitude: p.lng })) };
    setReportArea(area, saved.name);
  };

  return (
    <Card>
      <Card.Header>{t("Title.Area")}</Card.Header>
      <Card.Body>
        <Row>
          <Col>
            <AsyncSelect
              className="menu-outer-bottom"
              classNamePrefix="select"
              cacheOptions
              defaultOptions
              isClearable
              loadOptions={areaLoadOptions}
              onChange={handleAreaChange}
              placeholder="Buscar área... (opcional)"
              noOptionsMessage={() => "Nenhum resultado"}
              loadingMessage={() => "Buscando..."}
              value={areaSelectedOption}
            />
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
};

const mapStateToProps = state => ({
  props: {
    currentUser: state.users.currentUser
  }
});

const mapDispatchToProps = dispatch => ({
  funcs: bindActionCreators(Object.assign({}, ReportAreaActions), dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(memo(FilterSavedArea));
